<template>
  <div
    :style="`background: ${colors.light}`"
    class="service-icon-wrapper"
  >
    <Icon
      :name="serviceIcon"
      :size="calculatedIconSize"
      :style="`color: ${colors.dark}`"
    />
    <DirectTag
      v-if="isDirect"
      class="direct"
      :small="calculatedIconSize < 21"
    />
  </div>
</template>

<script>
import { serviceIcon } from '@officeguru/webapp-shared/src/helpers/service-helper';
import Icon from './Icon.vue';
import DirectTag from './direct/direct-tag.vue';

export default {
  name: 'ServiceIconVerified',
  components: { Icon, DirectTag },
  props: {
    servicePlainTextId: {
      type: Number,
      required: true,
    },
    serviceName: {
      type: String,
      required: true,
    },
    calculatedIconSize: {
      type: Number,
      required: true,
    },
    isDirect: {
      type: Boolean,
    },
  },
  data() {
    return {
      colors: {
        light: 'rgba(238, 133, 31, 0.06)',
        dark: 'rgb(238, 133, 31)',
      },
    };
  },
  computed: {
    serviceIcon() {
      return serviceIcon({
        id: this.servicePlainTextId,
        name: this.serviceName,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/main";

.service-icon-wrapper {
  position: relative;
}

.direct {
  position: absolute;
  bottom: 0;
}
</style>
